import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// FontAwesome.
import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';

// Hooks.
import useCopyToClipboard from 'app/client/utilities/hooks/useCopytoClipboard';

// Styled.
import * as S from './styled';

// The name is what gets pasted elsewhere, so the whole chip is the button.
const CopyableKey = ({ value, type }) => {
  const { t } = useTranslation();
  const [isCopied, handleCopy] = useCopyToClipboard(1500);

  return (
    <S.Chip
      type="button"
      aria-label={t('core:common.copy', { type })}
      $copied={isCopied}
      data-copied={isCopied || undefined}
      onClick={() => handleCopy(value)}
    >
      <S.Name>{value}</S.Name>
      {/* The kit carries no solid `copy`, so the check stays light beside it. */}
      <S.CopyIcon icon={byPrefixAndName.fal.copy} />
      <S.CheckIcon icon={byPrefixAndName.fal.check} />
    </S.Chip>
  );
};

CopyableKey.propTypes = {
  value: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default CopyableKey;
